import { Component, Host, Prop, h, Event, type EventEmitter } from '@stencil/core'

@Component({
  tag: 'cobalt-toggle',
  styleUrl: 'cobalt-toggle.css'
})
export class CobaltToggle {
  /**
   * The label that accompany the toggle. It is **required** for accessibility concerns.
   */
  @Prop({ mutable: true, reflect: true }) label!: string
  /**
   * Description will append below the label.
   */
  @Prop({ mutable: true }) description?: string
  /**
   * A string indicating the position of the label or if it is hidden.
   */
  @Prop({ mutable: true }) format?: 'right' | 'left' | 'hidden' = 'right'
  /**
   * A Boolean indicating whether the toggle is selected or not.
   *
   * It should be false if the toggle is `indeterminate`.
   */
  @Prop({ mutable: true }) selected?: boolean = false
  /**
   * A boolean indicating the disable state of the Toggle. The `aria-disabled` attribute relies on this property.
   */
  @Prop() disabled?: boolean = false
  /**
   * Emitted when the selected value has changed.
   */
  @Event() cobaltToggleChange: EventEmitter<boolean>

  handleToggle = (): void => {
    if (this.disabled) return
    this.selected = !this.selected
    this.cobaltToggleChange.emit(this.selected)
  }

  render(): any {
    return (
      <Host>
        <core-toggle
          label={this.label}
          description={this.description}
          selected={this.selected}
          format={this.format}
          disabled={this.disabled}
          onCoreToggleChange={this.handleToggle}
        ></core-toggle>
      </Host>
    )
  }
}
